export default __webpack_public_path__ + "static/media/prebooking.603ebbbe.svg";